<template>
  <div id="search">
    <FiltersSearch />
    <List />
  </div>
</template>

<script>
import FiltersSearch from "./FiltersSearch.vue";
import List from "./List.vue";

export default {
  name: "Search",

  components: {
    FiltersSearch,
    List,
  },

  created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const s = urlParams.get("s");

    if (s != "") {
      this.$store.commit("UPDATE_SEARCH", s);
    }

    this.$store.dispatch("newRequest");
  },
};
</script>
